var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconNotifications = function SvgIconNotifications(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.021 13-1.23 2h12.418l-1.23-2h.02V9a5.002 5.002 0 0 0-3.615-4.806c.113-.208.177-.444.177-.694 0-.823-.694-1.5-1.561-1.5s-1.56.677-1.56 1.5c0 .25.063.486.176.694A5.002 5.002 0 0 0 5.001 9v4h.02zM13 17a3 3 0 1 1-5.998 0H2a1 1 0 0 1-.851-1.524L3 12.467V9c0-2.584 1.4-4.841 3.483-6.054C6.754 1.273 8.23 0 10 0s3.246 1.273 3.516 2.946A6.997 6.997 0 0 1 17 9v3.467l1.851 3.009A1 1 0 0 1 18 17h-5z",
    fill: "#525254",
    fillRule: "evenodd"
  })));
};

export default SvgIconNotifications;